// Scoreboard backend. Baked in so a build still reaches production even if
// VITE_API_URL is missing from the deployment environment; set that variable
// to override (e.g. http://localhost:8000 when running the API locally).
const API = (import.meta.env.VITE_API_URL || 'https://osebackend.stablehosts.site').replace(/\/+$/, '')

// Canonical message the wallet signs. Must match the backend exactly.
export function scoreMessage(game, address, score, ts) {
  return (
    'Ose Games score verification\n' +
    `game: ${game}\n` +
    `address: ${address.toLowerCase()}\n` +
    `score: ${score}\n` +
    `ts: ${ts}`
  )
}

export async function submitScore(game, address, score, ts, signature) {
  const res = await fetch(`${API}/api/scores`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ game, address, score, ts, signature }),
  })
  if (!res.ok) throw new Error(`Submit failed: ${res.status}`)
  return res.json() // { best, newBest, rank }
}

export async function fetchLeaderboard(game, limit = 10) {
  const res = await fetch(`${API}/api/leaderboard/${game}?limit=${limit}`)
  if (!res.ok) throw new Error(`Leaderboard failed: ${res.status}`)
  return res.json() // { game, entries: [{ rank, address, score }] }
}
